import OrgWidgets from 'features/organizations/components/organisms/OrgWidgets/OrgWidgets';

export default OrgWidgets;
